import Chart from 'chart.js/auto'

document.addEventListener('turbolinks:load', () => {
  // 既存のチャートを破棄
  if (window.salesChart) {
    window.salesChart.destroy();
  }
  
  if (document.getElementById('company-sales') != null) {
    const context = document.getElementById('company-sales').getContext('2d');
    const displayType = context.canvas.dataset.displayType || 'daily';
    
    let chartType = 'bar';
    let label = '売上高';
    
    // 時間帯別の場合は折れ線グラフにする
    if (displayType === 'hourly') {
      chartType = 'line';
    }
    
    window.salesChart = new Chart(context, {
      type: chartType,
      data: {
        labels: JSON.parse(context.canvas.dataset.labels),
        datasets: [
          {
            label: label,
            backgroundColor: chartType === 'line' ? "rgba(12, 201, 167, 0.2)" : "#0CC9A7",
            borderColor: "#0CC9A7",
            hoverBackgroundColor: "#0AA995",
            data: JSON.parse(context.canvas.dataset.salesData),
            fill: chartType === 'line',
            tension: 0.1
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return value.toLocaleString() + '円';
              }
            }
          }
        }
      }
    });
  }
  
  // 決済比率のチャート
  if (document.getElementById('payments-ratio') != null) {
    const context = document.getElementById('payments-ratio').getContext('2d');
    const graph_data = JSON.parse(context.canvas.dataset.paymentsData);
    const color_list = [];
    for (let i in graph_data) {
      if (i == 0) {
        color_list.push("#0CC9A7")
      } else if (i == 1) {
        color_list.push("#0AA995")
      } else if (i == 2) {
        color_list.push("#088A7A")
      } else if (i == 3) {
        color_list.push("#066B5C")
      } else {
        color_list.push("#4DD4C1")
      }
    }
    
    // 既存のチャートを破棄
    if (window.paymentsRatioChart) {
      window.paymentsRatioChart.destroy();
    }
    
    window.paymentsRatioChart = new Chart(context, {
      type: 'doughnut',
      data: {
        labels: JSON.parse(context.canvas.dataset.labels),
        datasets: [
          {
            label: "",
            backgroundColor: color_list,
            hoverBackgroundColor: "#0AA995",
            data: JSON.parse(context.canvas.dataset.paymentsData),
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 15,
            right: 15,
            top: 15,
            bottom: 10
          }
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 8,
              font: {
                size: 11
              },
              boxWidth: 12,
              usePointStyle: true
            }
          }
        }
      }
    });
  }
})
